import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQueryMobile = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};

  `;
};

export const GeneralContent = styled.div`
  display: flex;
  flex-direction: column;
  ${handleQueryMobile(css`
    flex-direction: column-reverse;
  `)}
`;

export const Container = styled.div`
  display: flex;
  margin-top: 16px;
  overflow: hidden;
  flex-wrap: wrap;
  ${handleQueryMobile(css`
    display: flex;
    flex-direction: column;
  `)}
`;

export const GridItem = styled.div`
  padding: 10px 0;
  text-align: left;
`;

export const Item = styled.div`
  ${handleQueryMobile(css``)}
`;

export const ContentLegenda = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
  ${handleQueryMobile(css`
    align-items: flex-start;
    flex-direction: column;
  `)}
`;
export const ContainerLegenda = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${handleQueryMobile(css``)}
`;
export const Quadrado = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${({ color }) => color};
  ${handleQueryMobile(css``)}
`;
